import useSWR, { SWRResponse } from "swr";
import { CompilationTheme } from "@memento/types/compilation-theme";
import { getLoadingStatus, useUnauthenticatedFetcher } from "src/libs/fetcher";

export const UseCompilationThemesCacheKey = "/compilation-themes";

export const useCompilationThemes = () => {
  const fetcher = useUnauthenticatedFetcher();
  const key = UseCompilationThemesCacheKey;

  const { data, error }: SWRResponse<CompilationTheme[], Error> = useSWR(
    key,
    (url: string) => fetcher(url)
  );

  return {
    themes: data || null,
    error,
    status: getLoadingStatus(key, data, error),
  };
};
